module.exports = __webpack_public_path__ + "static/img/banner_defult.09238370.png";